import Client from './client/client';
import ClientAdminComponent from './client-admin-component';
import ClientAdminService from './client-admin-service';
import ClientAddModal from './client-add-modal/client-add-modal';
import FacilityRow from './facility-row/facility-row';
import CampusRow from './campus-row/campus-row';
import CombinedSearch from './combined-search/combined-search';

const clientAdmin = angular
    .module('FacilityData.ClientAdmin', [
        Client,
        ClientAddModal,
        FacilityRow,
        CampusRow,
        CombinedSearch
    ])
    .component('clientAdmin', ClientAdminComponent)
    .service('ClientAdminService', ClientAdminService)
    .config(($stateProvider) => {
        'ngInject';

        $stateProvider.state('app.client-admin', {
            url:'/client-admin/',
            component: 'clientAdmin',
            resolve: {
                userAuth: (
                    $state,
                    updateUser,
                    CurrentUser
                ) => {
                    if (!CurrentUser.isClientAdmin()) {
                        $state.go('app.home', {}, {reload: true});
                    }
                },
                clientList: (CommonRequest) => CommonRequest.getClients({all: 1, has_user_permissions: 1}),
                facilityList: (ClientAdminService) => ClientAdminService.getAllFacilities(),
                campusList: (ClientAdminService) => ClientAdminService.getAllCampuses(),
                groupList: (ClientAdminService) => ClientAdminService.getGroups()
            }
        });

    })
    .name;

export default clientAdmin;


// WEBPACK FOOTER //
// ./app/components/client-admin/client-admin.js